/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookRequestDTO } from '../models/BookRequestDTO'
import type { BookResponseDTO } from '../models/BookResponseDTO'
import type { ReleaseRequestDTO } from '../models/ReleaseRequestDTO'
import type { ReleaseResponseDTO } from '../models/ReleaseResponseDTO'
import type { ReserveRequestDTO } from '../models/ReserveRequestDTO'
import type { ReserveResponseDTO } from '../models/ReserveResponseDTO'
import type { SlotsResponseDTO } from '../models/SlotsResponseDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenSchedulerService {
    /**
     * Get Slots
     * @returns SlotsResponseDTO Successful Response
     * @throws ApiError
     */
    public static getSlotsSchedulerSlotsGet({
        study,
        start,
        end,
        language = 'en',
        timeZone
    }: {
        study: string
        /**
         * ISO date, inclusive
         */
        start: string
        /**
         * ISO date, inclusive
         */
        end: string
        language?: string
        /**
         * IANA zone used to group slots by date; display only.
         */
        timeZone?: string | null
    }): CancelablePromise<SlotsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/scheduler/slots',
            query: {
                study: study,
                start: start,
                end: end,
                language: language,
                timeZone: timeZone
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Reserve
     * @returns ReserveResponseDTO Successful Response
     * @throws ApiError
     */
    public static reserveSchedulerReservePost({ requestBody }: { requestBody: ReserveRequestDTO }): CancelablePromise<ReserveResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/scheduler/reserve',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Release
     * Hand a hold back before it expires (APP-1216, D15/D-G).
     *
     * Called when a patient changes slot or abandons the form. Without it an
     * abandoned checkout keeps the slot out of everyone else's grid for the full
     * ``SLOT_HOLD_MINUTES``, which on a round-robin event type with few available
     * hosts is real lost capacity.
     *
     * **Always answers 200.** A hold that has already expired, was already
     * released, or never existed all produce the same response, because:
     *
     * * the endpoint is public, so a 404 on an unknown uid would let a caller
     * enumerate live reservation ids;
     * * the caller's intent — stop holding this slot — is satisfied in every one
     * of those cases, so an error would invite a pointless retry;
     * * this runs on abandonment paths (``beforeunload``, unmount) where nothing
     * is listening for a failure anyway.
     *
     * Upstream failures are logged and swallowed for the same reason. The hold
     * expires on its own, so the worst case of a failed release is the behaviour
     * we have today.
     * @returns ReleaseResponseDTO Successful Response
     * @throws ApiError
     */
    public static releaseSchedulerReleasePost({ requestBody }: { requestBody: ReleaseRequestDTO }): CancelablePromise<ReleaseResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/scheduler/release',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Book
     * @returns BookResponseDTO Successful Response
     * @throws ApiError
     */
    public static bookSchedulerBookPost({ requestBody }: { requestBody: BookRequestDTO }): CancelablePromise<BookResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/scheduler/book',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
